


















import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KCardHeader, KCardHeaderBtn,
} from '@kasasa/fbase-components';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import FileLoadHistoryTable from '@/components/fileloadhistory/FileLoadHistoryTable.vue';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    FileLoadHistoryTable,
  },
})
export default class FileLoadHistory extends Vue {
    headerItems: any = [{
      text: 'Rewards Processing',
      disabled: false,
      link: false,
    },
    {
      text: 'File Load History',
      disabled: true,
    }];
}
